import { PesticideDetails } from "../../../../models/chemicalization/pesticides";
import { Button, Col, Input, Row } from "antd";
import { CloseOutlined, PlusCircleOutlined } from "@ant-design/icons";
import SelectPesticidesType from "../../../../components/selects/SelectPesticidesType";
import React, { useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

interface IProps {
  setItems: (items: PesticideDetails[]) => void;
  items: PesticideDetails[] | null;
}

export const PesticidesItems: React.FC<IProps> = ({ setItems, items }) => {
  const { t } = useTranslation();

  const [ pesticideItems, setPesticideItems ] = useState<PesticideDetails[]>([]);

  // Функция для генерации уникального ключа
  const generateUniqueKey = (): number => {
	return Math.random();
  };

  // Создание нового элемента с уникальным ключом
  const createNewItem = (): PesticideDetails => ({
	key: generateUniqueKey(),
	id: null,
	neededTonnes: null,
	suppliedTonnes: null,
	pesticidesTypeId: null,
  });

  useEffect(() => {
	if (items && items.length > 0) {
	  const itemsWithKeys = items.map((item) => ({
		...item,
		key: item.key || generateUniqueKey(),
	  }));
	  setPesticideItems(itemsWithKeys);
	} else {
	  setPesticideItems([createNewItem()]);
	}
  }, []);

  useEffect(() => {
	setItems(pesticideItems);
  }, [pesticideItems]);

  const handleAddItem = useCallback(() => {
	setPesticideItems((prevItems) => [...prevItems, createNewItem()]);
  }, []);

  const handleDeleteItem = useCallback(
	(key: number) => {
	  if (pesticideItems.length > 1) {
		const updatedItems = pesticideItems.filter((item) => item.key !== key);
		setPesticideItems(updatedItems);
		setItems(updatedItems);
	  }
	},
	[pesticideItems, setItems]
  );

  const handleInputChange = (
	key: number,
	field: keyof PesticideDetails,
	value: any
  ) => {
	const updatedPesticideItems = pesticideItems.map((item) =>
	  item.key === key ? { ...item, [field]: value } : item
	);
	setPesticideItems(updatedPesticideItems);
	setItems(updatedPesticideItems);
  };

  const isFieldEmpty = (value: any) => {
	return value === null || value === undefined || value === "";
  };

  return (
	<div style={ { marginTop: 15 } }>
	  { pesticideItems.map((item) => (
		<div key={ item.id } className="block_item_form massive_blocks">
		  <Button
			type="primary"
			className="fixed_delete"
			danger
			icon={ <CloseOutlined/> }
			shape="circle"
			size="small"
			disabled={ pesticideItems.length === 1 }
			onClick={ () => handleDeleteItem(item.key as number) }
		  />
		  <Row style={ { margin: 0 } } gutter={ 16 }>
			<Col className="gutter-row" span={ 12 }>
			  <label>{ t("titles.types_of_pesticides") }</label>
			  <SelectPesticidesType
				value={ item.pesticidesTypeId || null }
				onChange={ (value) =>
				  handleInputChange(item.key as number, "pesticidesTypeId", value)
				}
				status={ isFieldEmpty(item.pesticidesTypeId) ? "error" : "" }
			  />
			</Col>
			<Col className="gutter-row" span={ 12 }>
			  <label>{ t("chemicalization.register_of_pesticides.needed_tonnes") }</label>
			  <Input
				type="number"
				className={ isFieldEmpty(item.neededTonnes) ? "error-border" : "" }

				value={ item.neededTonnes || "" }
				onChange={ (e) =>
				  handleInputChange(item.key as number, "neededTonnes", Number(e.target.value))
				}
			  />
			</Col>
			<Col className="gutter-row" span={ 12 }>
			  <label>{ t("chemicalization.register_of_pesticides.supplied_tonnes") }</label>
			  <Input
				type="number"
				className={ isFieldEmpty(item.suppliedTonnes) ? "error-border" : "" }

				value={ item.suppliedTonnes || "" }
				onChange={ (e) =>
				  handleInputChange(item.key as number, "suppliedTonnes", Number(e.target.value))
				}
			  />
			</Col>
		  </Row>
		</div>
	  )) }
	  <Button
		style={ { marginTop: 15 } }
		icon={ <PlusCircleOutlined/> }
		type="primary"
		onClick={ handleAddItem }
	  >
		{ t("Добавить еще элемент") }
	  </Button>
	</div>
  );
};
